import styles from "./styles.module.css";
import { MdChevronRight } from "react-icons/md";
import { db } from "../../firebase";
import { useState, useEffect, useContext } from "react";
import { AppDisbatch } from "../../contexts/app";
import Search from "./search";

export default function Sidebar({ plugins, active, appId, setActive, onAdd }) {
  const [open, setOpen] = useState(false);
  const [allPlugins, setAllPlugins] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const disbatch = useContext(AppDisbatch);

  const fetchPlugins = () =>
    db
      .collection("plugins")
      .orderBy("name", "desc")
      .limit(20)
      .get()
      .then((snap) => {
        let docs = [];
        snap.forEach((doc) => docs.push({ id: doc.id, ...doc.data() }));
        return docs;
      });

  useEffect(
    () =>
      fetchPlugins().then((data) => {
        if (!plugins || Object.keys(plugins).length === 0) return null;
        const _pluginIds = Object.keys(plugins);
        const _plugins = data.filter((cur) => !_pluginIds.includes(cur.id));
        setAllPlugins(_plugins);
      }),
    [plugins]
  );

  useEffect(() => {
    if (!open) setSearchValue("");
  }, [open]);

  const filterPlugins = (val) => {
    if (val === "") return allPlugins;
    return allPlugins.filter((cur) =>
      cur.name.toLowerCase().includes(val.toLowerCase())
    );
  };

  const handleAdd = async (plugin) => {
    await db
      .collection("apps")
      .doc(appId)
      .collection("plugins")
      .add({
        plugin: plugin.id,
        version: plugin.versions[plugin.versions.length - 1],
        config: {},
      });
    setOpen(false);
  };

  return (
    <div className={styles.sidebar}>
      <div className={styles.button} onClick={() => setOpen(true)}>
        ADD PLUGIN
      </div>

      <Search
        open={open}
        plugins={Object.values(plugins).map((x) => x.plugin.name)}
        onAdd={handleAdd}
        onClose={() => setOpen(false)}
      />
      <div className={styles.container}>
        {!!plugins
          ? Object.keys(plugins).map((key, index) => (
              <ListItem
                key={index}
                id={key}
                plugin={plugins[key]}
                onClick={setActive}
                active={key === active}
              />
            ))
          : null}
      </div>
    </div>
  );
}

function ListItem({ plugin, active, id, onClick }) {
  return (
    <div
      className={active ? `${styles.item} ${styles.active}` : styles.item}
      onClick={() => onClick(id)}
    >
      <div>{plugin.plugin.displayName}</div>
      <MdChevronRight />
    </div>
  );
}
